import React from 'react';
import { Box, Typography } from '@mui/material';
import LynaAvatar from './LynaAvatar';
import '../cat-theme.css';

interface CatLoadingSpinnerProps {
    message?: string;
}

const CatLoadingSpinner: React.FC<CatLoadingSpinnerProps> = ({
    message = 'Nuestros gatitos están organizando todo...'
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '200px',
                gap: 2,
            }}
        >
            <Box
                sx={{
                    animation: 'michibounce-kawaii 1s infinite alternate',
                    '@keyframes michibounce-kawaii': {
                        from: { transform: 'scale(1) rotate(-5deg)' },
                        to: { transform: 'scale(1.1) rotate(5deg)' }
                    }
                }}
            >
                <LynaAvatar size={100} isWalking={true} />
            </Box>
            <Typography
                variant="body1"
                sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    fontStyle: 'italic'
                }}
            >
                {message}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <span className="cat-paw-trail" style={{ animationDelay: '0s' }}>🐾</span>
                <span className="cat-paw-trail" style={{ animationDelay: '0.3s' }}>🐾</span>
                <span className="cat-paw-trail" style={{ animationDelay: '0.6s' }}>🐾</span>
            </Box>
        </Box>
    );
};

export default CatLoadingSpinner;
